module.exports = {
    content: [
        './src/**/*.html',
        './src/**/*.js',
        './src/**/*.jsx',
        './src/**/*.ts',
    ],
    theme: {
        extend: {
            //https://www.tailwindshades.com/
            colors: {
                primary: {
                    DEFAULT: '#163B59',
                    50: '#B4D3ED',
                    100: '#A4CAE9',
                    200: '#83B7E0',
                    300: '#63A4D8',
                    400: '#4291D0',
                    500: '#2E7CBB',
                    600: '#26669A',
                    700: '#1E517A',
                    800: '#163B59',
                    900: '#0B1D2C',
                    950: '#050E16'
                },
                secondary: {
                    DEFAULT: '#CC432F',
                    50: '#F9E6E3',
                    100: '#F5D7D2',
                    200: '#EDB9B1',
                    300: '#E59B90',
                    400: '#DE7D6F',
                    500: '#D65F4E',
                    600: '#CC432F',
                    700: '#9E3424',
                    800: '#71251A',
                    900: '#43160F',
                    950: '#2C0F0A'
                },
            },
        },
    },
    plugins: [],
    prefix: 'tw-',
    safelist: [
        {
            pattern: /(bg|text|border|outline)-primary.*/
        },
        {
            pattern: /(bg|text|border|outline)-secondary.*/
        },
        {
            pattern: /m[trblxy]?-/,
        },
        {
            pattern: /shadow-.*/
        },
    ]
};
